import React from 'react';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import useDropDownStyles from './styles';

const DropDown = ({ label, value, onChange, error, MenuData, helperText, rectangle }) => {
  const classes = useDropDownStyles();
  return <div className={classes.root}>
    <FormControl sx={{ width: "100%" }}>
      <InputLabel id="demo-simple-select-filled-label">
        {label}
      </InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        value={value}
        onChange={onChange}
        error={error}
        sx={{
          borderRadius: rectangle === true ? "5px" : "50px",
          backgroundColor: "#fff",
          boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
        }}
      >
   
        {MenuData && MenuData.map((data) =>
          <MenuItem value={data}>{data}</MenuItem>
        )}
      </Select>
    </FormControl>
    {
      error && helperText &&
      <div style={{ fontSize: 12, color: 'red', marginLeft: '20px' }} >{helperText}</div>
    }
  </div >;
};

DropDown.propTypes = {};

export default DropDown;
